import { render, staticRenderFns } from "./CreateCampaignSourceFavorites.vue?vue&type=template&id=51ca429e&scoped=true"
import script from "./CreateCampaignSourceFavorites.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSourceFavorites.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignSourceFavorites.vue?vue&type=style&index=0&id=51ca429e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ca429e",
  null
  
)

export default component.exports